import React from 'react';

import Modal from "../../../../component/modal/ModalTemplate";

import * as apiUtil from "../../../../util/apiUtil";
import Loading from "../../../../component/loading/Loading";

class AccountInfoUploadModal extends React.Component {
    constructor(props) {
        super(props);

        this.setLoading = this.setLoading.bind(this);
        this.handleFile = this.handleFile.bind(this);
        this.state = {
            loading: false,
            file: null,
        }
    }// end constructor

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        return (
            this.state.loading !== nextState.loading
            || this.state.file !== nextProps.file
            || this.props.isOpen !== nextProps.isOpen
        )
    }

    setLoading(loading) {
        this.setState({ loading: loading });
    }

    handleFile = (e) => {
        this.setState({ file: e.target.files[0] });
    }

    handleRefund = () => {
        if (! window.confirm("환불 신청 하시겠습니까?")) return;

        /* 무통장입금 환불 */
        const { paymentInfo } = this.props;
        const { file } = this.state;

        let data = new FormData();
        data.append('cashPaymentId', paymentInfo.uid)
        data.append('bankBookImg', file);

        apiUtil.asyncRequest({
            setLoading: this.setLoading,
            url: "/api/cash/payment/refund",
            method: apiUtil.requestMethod.POST,
            data: data,
            isFile: true,
            success: (result) => {
                alert('(무통장입금) 환불 신청이 정상적으로 완료되었습니다.');
                window.location.reload();
            }
        })
    }

    render() {
        const { loading } = this.state;
        const { isOpen, handleClose, paymentInfo } = this.props;
        const { file } = this.state;
        const { handleFile, handleRefund } = this;

        return (
            <Modal
                open={isOpen}
                handleClose={handleClose}
                modalTitle={"통장사본확인"}
                className={"react-modal"}
                paymentInfo={paymentInfo}
            >
                <Loading loading={loading}/>
                <div className='modal-body'>
                    <p>환불 받을 통장 사본을 업로드 해주세요</p>
                    <small className='pe-2 text-danger'>* 고객사 법인 통장만 가능합니다.</small>

                    <br/><br/><br/>

                    통장 사본 (필수) <input type="file" onChange={handleFile}/>
                </div>
                <hr/>
                <div className='modal-footer'>
                    <button className='btn btn-primary btn-md me-2' disabled={file === null} onClick={handleRefund}>확인</button>
                    <button className='btn btn-secondary btn-md' onClick={handleClose}>취소</button>
                </div>
            </Modal>
        )
    }
}


export default AccountInfoUploadModal;
